<button class="btn btn-sm btn-primary rounded ml-4 mt-4" (click)="resetContract()">
  {{ 'myContracts.returnContracts' | translate }}
</button>

<div class="mx-4 mt-4 mb-2">
  <app-my-contracts-header [contract]="contract" />
</div>

<div class="mx-4">
  <app-contract-filters-actionbar [filterValues]="filterValues" (onSelect)="this.onChangeFilter($event)" />
</div>

<ul
  ngbNav
  #navContract="ngbNav"
  [(activeId)]="activeTab"
  (navChange)="onTabChange($event)"
  class="nav-tabs border-bottom ml-4 mt-4 mr-4"
>
  <li id="{{ 'tabs-contract-history' }}" ngbNavItem="history" [domId]="'contract-history'">
    <button ngbNavLink>
      {{ 'myContracts.history' | translate }}
    </button>
    <ng-template ngbNavContent>
      <app-contract-graphs *ngIf="invoicingBuckets" [contract]="contract" [invoicingBuckets]="invoicingBuckets" />
    </ng-template>
  </li>

  <li id="{{ 'tabs-contract-sites' }}" ngbNavItem="sites" [domId]="'contract-sites'">
    <button ngbNavLink>
      {{ 'myContracts.sites' | translate }}
    </button>
    <ng-template ngbNavContent>
      <app-contract-sites [contractNumber]="contract.number" [filter]="this.filter" />
    </ng-template>
  </li>

  @if (contract.nbInvoicedClusters > 0) {
    <li id="{{ 'tabs-contract-clusters' }}" ngbNavItem="clusters" [domId]="'contract-clusters'">
      <button ngbNavLink>
        {{ 'clusters' | titlecase | translate }}
      </button>
      <ng-template ngbNavContent>
        <app-contract-clusters [contractNumber]="contract.number" [filter]="this.filter" />
      </ng-template>
    </li>
  }
</ul>

<div [ngbNavOutlet]="navContract" class="p-3 mr-4 ml-4 mb-4 border"></div>
